import { render } from "./WidgetPreview.vue?vue&type=template&id=f45fded4&scoped=true"
import script from "./WidgetPreview.vue?vue&type=script&lang=js"
export * from "./WidgetPreview.vue?vue&type=script&lang=js"

import "./WidgetPreview.vue?vue&type=style&index=0&id=f45fded4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f45fded4"]])

export default __exports__